import { get } from 'lodash-es';

const byVacationHitGroups = (state: any) =>
  get(state, 'properties.vacationHitGroups');

export default byVacationHitGroups;
